import ActiveRecordResource from './ActiveRecordResource';
import config from 'config';
import {utility} from "../utilites/index";

export interface ProductDto {
  id?:string;
}

export class Product extends ActiveRecordResource {
  static path = `${config.backOfficeBasePath}/shop/products`;

  static validateConstraints = {};

  static mapRecords(data) {
    return data.map((item) => new Product(item));
  }

  _getModel() {
    return Product;
  }

  static listAction(query, perPage = 50, page = 0) {
    let path = this.path;
    if (query.sponsored) {
      path += '/sponsored';
    }

    query = Object.assign({}, query, {
      page,
      perPage
    });

    return utility.networkLayer.getJson(path, query)
      .then(data => this.mapRecords(data));
  }

}

export default Product;



// WEBPACK FOOTER //
// ./src/api/product.ts